// import homePageImg from '../assets/images/homepage.png'
import '../assets/css/homepage.css';
import '../assets/css/mediaQueries.css';

import Im from './Im';
import SocialMedia from './SocialMedia';

const Home = () => {



    return (
        <>

            <div className="home_container">

                <div className="background-2">

                </div>
                <div className="background-image-container-parent">
                    <div className="profile-image-container"></div>

                    <div className="profile-text-container">
                        <div className="name-style">Md Mohib Khan</div>
                        <Im />
                        <div className="short-intro">I am a highly skilled and experienced web developer with 4+ years of experience creating responsive and engaging websites and web applications. Passionate about delivering high-quality work on time. </div>

                    </div>

                </div>

                <div className="profile-text-container2">
                    <div className="name-style">Md Mohib Khan</div>
                    <Im />
                    <div className="short-intro">I am a highly skilled and experienced web developer with 4+ years of experience creating responsive and engaging websites and web applications. Passionate about delivering high-quality work on time. </div>
                </div>
                <SocialMedia />

            </div>


        </>
    );
}

export default Home;